import type { ViewOptionsStruct } from '@/engine/app/interfaces';
import { useCallback, useState } from 'react';
import { viewOptionsStructureManager } from '@/components/viewOption/viewOptionsStructure';

type CollapsingState = Record<string, boolean>;

export const useCollapsingState = (
  viewOptions: ViewOptionsStruct | undefined
): [CollapsingState, (id: string) => void, (viewOptions: ViewOptionsStruct | undefined) => void] => {
  const defaultCollapsing = viewOptionsStructureManager.getGroupsCollapsingState(viewOptions);

  const [collapsingState, setCollapsingState] = useState<CollapsingState>(defaultCollapsing);

  const toggleCollapse = (id: string): void => setCollapsingState((state) => ({ ...state, [id]: !state[id] }));

  const resetCollapsingState = useCallback(
    (viewOptions: ViewOptionsStruct | undefined): void =>
      setCollapsingState(viewOptionsStructureManager.getGroupsCollapsingState(viewOptions)),
    []
  );

  return [collapsingState, toggleCollapse, resetCollapsingState];
};
